<template>
  <v-app>
    <v-main class="public-layout-main">
      <router-view/>
    </v-main>
  </v-app>
</template>

<script>
export default { name: 'PublicLayout' };
</script>

<style lang="scss" scoped>
@import '@/styles/colors.scss';

.public-layout-main {
  background-color: $light-surface-1;
  min-height: 100vh;
}
</style>
